import { render, staticRenderFns } from "./IncomeStatementReport.vue?vue&type=template&id=cb7de2dc"
import script from "./IncomeStatementReport.vue?vue&type=script&lang=js"
export * from "./IncomeStatementReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports